import { Describe, is, number, optional, string, type } from 'superstruct';

export type IconDto = {
  filename: string;
  free_tags: string;
  id: number;
  preview: string;
  short_description: string;
  title: string;
  type: string;
  url: string;
};

export const IconValidator: Describe<IconDto> = type({
  filename: string(),
  free_tags: optional(string()),
  id: number(),
  preview: optional(string()),
  short_description: optional(string()),
  title: string(),
  type: optional(string()),
  url: string(),
});

export const isIcon = (obj: unknown) => is(obj, IconValidator);
